import { Component, OnInit } from '@angular/core';
import { EquipamentoCategoria } from '../equipamento.model';
import { GenerateTableColumn, GenerateTablePageEvent, GenerateTablePagination } from 'src/app/shared/components';
import { EquipamentoCategoriaService } from './equipamento-categoria.service';
import { Router } from '@angular/router';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Pagination } from 'src/app/shared/models';
import { catchErr } from 'src/app/shared/utils';
import { ImgDialog } from '../../shared/components/img-dialog.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'equipamento-categoria',
    templateUrl: './equipamento-categoria.component.html',
    standalone: false
})
export class EquipamentoCategoriaComponent implements OnInit {

    loading = true;    
    dataSource: EquipamentoCategoria[];
    pagination: GenerateTablePagination = { total: 0, current: 0, pageSize: 10 }
    columns: GenerateTableColumn[] = [
        { header: 'Nome', attr: 'nome' },
        { header: 'Informações Adicionais', attr: 'descricao' },
        { header: 'Forma de Precificação', attr: 'formaPrecificacao' },
        {
            header: 'Imagens',
            template: (rowData: EquipamentoCategoria) => rowData.imagens && rowData.imagens.length ? `<span class="material-symbols-outlined text-primary pointer">photo_library</span>` : '---',
            click: {
              action: (rowData: EquipamentoCategoria) => rowData.imagens && rowData.imagens.length ? this.openDialog(rowData) : null
            }
        }, {
            tdClass: 'td-w-auto',
            btnProps: { label: 'Editar' },
            click: {
              action: (rowData: EquipamentoCategoria) => this.router.navigateByUrl(`/equipamento/categoria/${rowData.id}/editar`)
            }
        }
    ]

    constructor(
        private dialog: MatDialog,
        private categoriaService: EquipamentoCategoriaService,
        private router: Router,
        private snackBar: MatSnackBar
    ) { }

    ngOnInit() {
        this.search();
    }

    search(pageEvent?: GenerateTablePageEvent) {
        this.loading = true;
        this.pagination.current = pageEvent ? pageEvent.current : this.pagination.current
        this.pagination.pageSize = pageEvent ? pageEvent.pageSize : this.pagination.pageSize

        this.categoriaService.getPaginated<EquipamentoCategoria>(this.pagination.current, this.pagination.pageSize).subscribe({
            next: (res: Pagination<EquipamentoCategoria>) => {
                this.dataSource = res.data;
                this.pagination.total = res.total;
            }, error: (err) => catchErr(err, this.snackBar)
        }).add(() => this.loading = false);
    }

    private openDialog(grupo: EquipamentoCategoria) {
        this.dialog.open(ImgDialog, { data: grupo });
    }
}
